import { render } from "./batchCheckCompany.vue?vue&type=template&id=21b61322&scoped=true"
import script from "./batchCheckCompany.vue?vue&type=script&lang=js"
export * from "./batchCheckCompany.vue?vue&type=script&lang=js"

import "./batchCheckCompany.vue?vue&type=style&index=0&id=21b61322&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21b61322"

export default script